import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import pickBy from 'lodash/fp/pickBy';
import forEach from 'lodash/fp/forEach';
import Alert from '../Alert';
var dummyImg = 'https://i.ytimg.com/vi/LgkAebhJ7iE/maxresdefault.jpg';
function clone(children, props) {
  return React.cloneElement(children, pickBy(function (prop) {
    return prop !== void 0;
  }, props));
}
var TakeStateProvider = /*#__PURE__*/function (_Component) {
  function TakeStateProvider() {
    var _this;
    _classCallCheck(this, TakeStateProvider);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TakeStateProvider, [].concat(args));
    _defineProperty(_this, "state", {
      userResponse: void 0
    });
    // storage for the currently ongoing requests
    _defineProperty(_this, "uploadRequests", null);
    // generates the callback used when an upload has finished
    _defineProperty(_this, "makeUploadHandler", function (id, callback) {
      return function () {
        delete _this.uploadRequests[id];
        callback(dummyImg);
      };
    });
    _defineProperty(_this, "cancelMediaUpload", function (id) {
      clearTimeout(_this.uploadRequests[id]);
      delete _this.uploadRequests[id];
    });
    _defineProperty(_this, "handleResponseUpdate", function (value, properties) {
      _this.setState({
        userResponse: {
          value: value,
          properties: properties
        }
      });
    });
    _defineProperty(_this, "notifyScreenreader", function (content) {
      return _this.alert.setAlert(content);
    });
    _defineProperty(_this, "mediaUpload", function (id, file, callback) {
      // Simulates the upload of file
      // calls callback when the upload has finished
      if (_this.uploadRequests[id] !== void 0) {
        _this.cancelMediaUpload(id);
      }
      _this.uploadRequests[id] = setTimeout(_this.makeUploadHandler(id, callback), 2000 + Math.random() * 2000);
    });
    _defineProperty(_this, "handleAlertRef", function (node) {
      _this.alert = node;
    });
    return _this;
  }
  _inherits(TakeStateProvider, _Component);
  return _createClass(TakeStateProvider, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.uploadRequests = {};
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      forEach(clearTimeout, this.uploadRequests);
    }
  }, {
    key: "render",
    value: function render() {
      console.log('Current Response:', this.state.userResponse); // eslint-disable-line no-console

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Alert, {
        ref: this.handleAlertRef
      }), clone(this.props.children, {
        notifyScreenreader: this.notifyScreenreader,
        userResponse: this.state.userResponse,
        handleResponseUpdate: this.handleResponseUpdate,
        cancelMediaUpload: this.cancelMediaUpload,
        mediaUpload: this.mediaUpload
      }));
    }
  }]);
}(Component);
_defineProperty(TakeStateProvider, "propTypes", {
  children: PropTypes.node.isRequired
});
export { TakeStateProvider as default };